module.exports = __webpack_public_path__ + "img/3.da4a04ac.png";